/* eslint max-len: 0 */
import React, { SVGProps } from 'react';

const Router = (props: SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M2 8.53328C2 5.58777 4.44208 3.19995 7.45455 3.19995H8.54545C11.5579 3.19995 14 5.58777 14 8.53328V9.86662C14 10.144 13.9606 10.4123 13.8871 10.6666H12.7254C12.8432 10.4241 12.9091 10.1529 12.9091 9.86662V8.53328C12.9091 6.17687 10.9554 4.26662 8.54545 4.26662H7.45455C5.04458 4.26662 3.09091 6.17687 3.09091 8.53328V9.86662C3.09091 10.1529 3.15682 10.4241 3.27463 10.6666H2.11293C2.03936 10.4123 2 10.144 2 9.86662V8.53328Z"
        fill={props.fill || "#ED0037"}
      />
      <path
        d="M2.68572 11.7333C3.23598 12.3848 4.0684 12.8 5 12.8H11C11.9316 12.8 12.764 12.3848 13.3143 11.7333H2.68572Z"
        fill={props.fill || "#ED0037"}
      />
      <path
        d="M6.45675 10.6666H9.54325C9.60355 10.4998 9.63636 10.3203 9.63636 10.1333C9.63636 9.70464 9.46398 9.31537 9.18329 9.02813L10.8767 7.00438C10.9538 6.9124 11 6.79479 11 6.66662C11 6.37207 10.7558 6.13328 10.4545 6.13328C10.2816 6.13328 10.1274 6.21199 10.0275 6.33477L8.17985 8.54284C8.12079 8.53652 8.06078 8.53328 8 8.53328C7.09626 8.53328 6.36364 9.24963 6.36364 10.1333C6.36364 10.3203 6.39645 10.4998 6.45675 10.6666Z"
        fill={props.fill || "#ED0037"}
      />
      <path
        d="M8 5.86662C8.30125 5.86662 8.54545 5.62784 8.54545 5.33328C8.54545 5.03873 8.30125 4.79995 8 4.79995C7.69875 4.79995 7.45455 5.03873 7.45455 5.33328C7.45455 5.62784 7.69875 5.86662 8 5.86662Z"
        fill={props.fill || "#ED0037"}
      />
      <path
        d="M6.09091 6.66662C6.09091 6.96117 5.8467 7.19995 5.54545 7.19995C5.24421 7.19995 5 6.96117 5 6.66662C5 6.37207 5.24421 6.13328 5.54545 6.13328C5.8467 6.13328 6.09091 6.37207 6.09091 6.66662Z"
        fill={props.fill || "#ED0037"}
      />
      <path
        d="M4.72727 9.06662C4.72727 9.36117 4.48306 9.59995 4.18182 9.59995C3.88057 9.59995 3.63636 9.36117 3.63636 9.06662C3.63636 8.77207 3.88057 8.53328 4.18182 8.53328C4.48306 8.53328 4.72727 8.77207 4.72727 9.06662Z"
        fill={props.fill || "#ED0037"}
      />
      <path
        d="M11.8182 9.59995C11.5169 9.59995 11.2727 9.36117 11.2727 9.06662C11.2727 8.77207 11.5169 8.53328 11.8182 8.53328C12.1194 8.53328 12.3636 8.77207 12.3636 9.06662C12.3636 9.36117 12.1194 9.59995 11.8182 9.59995Z"
        fill={props.fill || "#ED0037"}
      />
    </svg>
  );
};

Router.displayName = 'Router';

export default Router;
